// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const SpaTypeDropdown = props =>
    <section className='spa-type'>
        <header>
            <FormattedMessage id='SPECIAL_ALLOWANCE_TYPE'/>
        </header>
        {props.isSpaTypeChangeAllowed ?
            <OptionsDropDown
                className='spa-type'
                isPlaceholderTranslated={false}
                isRequired={true}
                onChange={props.onSpaTypeChange}
                optionDisplayAttributes={['value']}
                optionKey='key'
                options={props.spaTypes}
                placeholder=''
                selectedValue={props.selectedType.key}
                showPlaceholder={false}
            /> :
                <span>
                    {props.selectedType.value}
                </span>
        }
    </section>;

SpaTypeDropdown.displayName = 'SpaTypeDropdown';
SpaTypeDropdown.propTypes = {
    isSpaTypeChangeAllowed: PropTypes.bool.isRequired,
    onSpaTypeChange: PropTypes.func.isRequired,
    selectedType: PropTypes.instanceOf(KeyValuePair),
    spaTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair))
};
export default SpaTypeDropdown;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/spa-type.js